// A nullish cost means the price never loaded; a free selection comes through as 0.
const hasResolvedCheckoutPrices = ({
  originalMembershipCost,
  trailerCareCost,
} = {}) => originalMembershipCost != null && trailerCareCost != null

export default hasResolvedCheckoutPrices
